import * as React from 'react';
import type {SxProps, TableFooter, TableFooterProps} from '@mui/material';
import type {FooterPropsOverrides} from '@mui/x-data-grid-pro';
import {
  GridFooterContainer,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import {PageSizePicker} from 'components/paginator';
import {DataGridPaginator} from './DataGridPaginator';

declare module '@mui/x-data-grid-pro' {
  interface FooterPropsOverrides {
    scrollAfterPagination?: boolean;
  }
}

const containerSx: SxProps = {
  flex: 1,
  justifyContent: 'end',
  p: 1,
};

export function CustomFooter({
  scrollAfterPagination,
}: TableFooterProps<typeof TableFooter, FooterPropsOverrides>) {
  const apiRef = useGridApiContext();

  const rootProps = useGridRootProps();
  const pageSizeOptions = rootProps.pageSizeOptions;
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);

  return (
    <GridFooterContainer sx={containerSx}>
      {/* Hack for overview table */}
      {
        <>
          <PageSizePicker
            size={paginationModel.pageSize}
            pageSizes={pageSizeOptions}
            setSize={size => {
              apiRef.current.setPaginationModel({
                ...paginationModel,
                pageSize: size,
              });
            }}
          />
        </>
      }
      {DataGridPaginator(scrollAfterPagination)}
    </GridFooterContainer>
  );
}
